import { withProps } from 'recompose';
import { isEditMode } from '../helpers/isEditMode';

const withHeading = withProps(props => ({
  heading: isEditMode(props) ? 'Barber details' : 'Add new staff member',
}));

export default withHeading;
